module.exports = __webpack_public_path__ + "img/179.4d9d091f.jpg";